module.exports = __webpack_public_path__ + "img/20240131155624515sws.5f3230e7.jpg";